module.exports = __webpack_public_path__ + "img/img_zhuanpan01@2x.afef4677.png";